import { render, staticRenderFns } from "./ListAnnounce.vue?vue&type=template&id=0030161c&scoped=true&"
import script from "./ListAnnounce.vue?vue&type=script&lang=js&"
export * from "./ListAnnounce.vue?vue&type=script&lang=js&"
import style0 from "./ListAnnounce.vue?vue&type=style&index=0&id=0030161c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0030161c",
  null
  
)

export default component.exports